// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useQuery } from 'Data/Api'
import useDataConfiguration from './useDataConfiguration'
import useDataOnSubmit from './useDataOnSubmit'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function EditInsuranceData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, fetching, error }, reExecuteQuery] = useQuery({ query, ...configuration })
  let data = rdata?.vaxiom_insurance_companies_by_pk
  let onSubmit = useDataOnSubmit(props, data, reExecuteQuery)

      useSetFlowToBasedOnData({
        data,
        fetching,
        error,
        pause: configuration.pause,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="carrier"
      value={data}
      viewPath={props.viewPath}
      onSubmit={onSubmit}
    >
      <View {...props} />
    </DataProvider>
  )
}